/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { isNumber } from "dc-preview-utils/src/Utils/DataTypeUtils";
import { JS_MOUSE_UP_TYPE } from "constants/constants";

export default class BaseEvent {
  constructor(eventData = {}) {
    this.change = eventData.change || "";
    this.changeEx = eventData.changeEx || "";
    this.commitKey = eventData.commitKey || 0;
    this.fieldFull = eventData.fieldFull || false;
    this.modifier = eventData.modifier || false;
    this.keyDown = eventData.keyDown || false;
    this.name = eventData.name;
    this.rc = eventData.rc || true;
    this.selEnd = isNumber(eventData.selEnd) ? eventData.selEnd : -1;
    this.selStart = isNumber(eventData.selStart) ? eventData.selStart : -1;
    this.shift = eventData.shift || false;
    this.type = eventData.type || JS_MOUSE_UP_TYPE;
    this.value = eventData.value || "";
    this.targetName = eventData.targetName || "";
    this.willCommit = eventData.willCommit || false;
    this.target = null;
    this.source = eventData.source || null;
  }
}
